/**
 * Initializes a Heap stub that queues method calls
 * until the real Heap SDK loads and replays them.
 *
 * This stub:
 * - Creates a global `window.heap` queue if it does not already exist.
 * - Defines temporary methods (e.g., track, addEventProperties, identify, etc.).
 * - Queues all Heap method calls made before the actual Heap script loads.
 *
 * Once the real Heap SDK is loaded via `heap.load()`, it:
 * - Replaces the stub methods with real implementations.
 * - Replays all queued calls in the original order.
 *
 * Important:
 * - This must run BEFORE any Heap method is called.
 * - Event properties only apply to events triggered AFTER they are queued.
 * - It does not retroactively modify events that were already sent.
 */
export default function initHeapStub() {
	window.heap = window.heap || [];
	const methods = ['track', 'identify', 'resetIdentity', 'addUserProperties', 'addEventProperties', 'removeEventProperty', 'clearEventProperties', 'getSessionId', 'unsetEventProperty', 'setEventProperties'];

	methods.forEach(function(method) {
		window.heap[method] = function() {
			window.heap.push([method].concat([].slice.call(arguments)));
		};
	});

	window.isHeapStubLoaded = true;

	const now = new Date();
	const userSessionStartedAt = now?.toLocaleString('en-US', {
		timeZone: 'America/Los_Angeles',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false
	});

	window.additionalEventProperties = {
		heapStubLoaded: true,
		userSessionStartedAt: `${userSessionStartedAt} (PT)`
	};
}
